var _rect, _rect2, _g, _rect3, _rect4, _circle, _circle2, _circle3, _path, _circle4, _path2, _circle5, _path3, _circle6, _path4, _circle7, _path5, _circle8, _path6, _circle9, _path7, _circle10, _path8, _circle11, _path9, _circle12, _path10, _circle13, _path11, _circle14, _path12, _circle15, _path13, _circle16, _path14, _circle17, _path15, _circle18, _path16, _circle19, _path17, _circle20, _path18, _circle21, _path19, _circle22, _path20, _circle23, _path21, _circle24, _path22, _circle25, _path23, _circle26, _path24, _circle27, _path25, _circle28, _path26, _circle29, _path27, _circle30, _path28, _circle31, _path29, _path30, _rect5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserExp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 590,
    height: 451,
    viewBox: "0 0 590 451",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 590,
    height: 450.957,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 76.0122,
    y: 74.3137,
    width: 376.442,
    height: 222.004,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_214_1952)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.969,
    y: 111.715,
    width: 392.127,
    height: 225.624,
    fill: "#3600CE"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 208.733,
    y: 337.339,
    width: 167.71,
    height: 39.8159,
    fill: "#444343"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 104.969,
    y: 110.51,
    width: 347.485,
    height: 185.808,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 364.695,
    cy: 137.269,
    r: 8.7641,
    fill: "#14D3A6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 424.386,
    cy: 137.269,
    r: 8.7641,
    fill: "#14D3A6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 394.539,
    cy: 137.269,
    r: 8.7641,
    fill: "#14D3A6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M148.809 174.259C150.086 171.857 153.1 170.991 155.457 172.352C157.812 173.711 158.571 176.752 157.131 179.059L151.849 187.519C150.577 189.557 147.919 190.221 145.839 189.019C143.759 187.819 143.004 185.188 144.131 183.068L148.809 174.259Z",
    fill: "url(#paint0_linear_214_1952)",
    fillOpacity: 0.47
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 153.089,
    cy: 176.471,
    r: 4.31353,
    fill: "#3700D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M178.574 174.259C179.85 171.857 182.865 170.991 185.221 172.352C187.576 173.711 188.335 176.752 186.895 179.059L181.614 187.519C180.342 189.557 177.684 190.221 175.603 189.019C173.524 187.819 172.769 185.188 173.895 183.068L178.574 174.259Z",
    fill: "url(#paint1_linear_214_1952)",
    fillOpacity: 0.47
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.855,
    cy: 176.471,
    r: 4.31353,
    fill: "#3700D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M208.338 174.259C209.615 171.857 212.629 170.991 214.986 172.352C217.341 173.711 218.1 176.752 216.66 179.059L211.378 187.519C210.106 189.557 207.448 190.221 205.368 189.019C203.289 187.819 202.533 185.188 203.66 183.068L208.338 174.259Z",
    fill: "url(#paint2_linear_214_1952)",
    fillOpacity: 0.47
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.619,
    cy: 176.471,
    r: 4.31353,
    fill: "#3700D3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M238.103 174.259C239.379 171.857 242.394 170.991 244.75 172.352C247.105 173.711 247.864 176.752 246.424 179.059L241.143 187.519C239.871 189.557 237.213 190.221 235.132 189.019C233.053 187.819 232.298 185.188 233.424 183.068L238.103 174.259Z",
    fill: "url(#paint3_linear_214_1952)",
    fillOpacity: 0.47
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.384,
    cy: 176.471,
    r: 4.31353,
    fill: "#3700D3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M267.868 174.259C269.144 171.857 272.159 170.991 274.515 172.352C276.87 173.711 277.629 176.752 276.189 179.059L270.907 187.519C269.635 189.557 266.977 190.221 264.897 189.019C262.818 187.819 262.063 185.188 263.189 183.068L267.868 174.259Z",
    fill: "url(#paint4_linear_214_1952)",
    fillOpacity: 0.47
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 272.148,
    cy: 176.471,
    r: 4.31353,
    fill: "#3700D3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M297.632 174.259C298.908 171.857 301.923 170.991 304.279 172.352C306.634 173.711 307.393 176.752 305.953 179.059L300.672 187.519C299.4 189.557 296.742 190.221 294.661 189.019C292.582 187.819 291.827 185.188 292.953 183.068L297.632 174.259Z",
    fill: "url(#paint5_linear_214_1952)",
    fillOpacity: 0.47
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 301.913,
    cy: 176.471,
    r: 4.31353,
    fill: "#3700D3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M327.397 174.259C328.673 171.857 331.688 170.991 334.044 172.352C336.399 173.711 337.158 176.752 335.718 179.059L330.436 187.519C329.164 189.557 326.506 190.221 324.426 189.019C322.347 187.819 321.592 185.188 322.718 183.068L327.397 174.259Z",
    fill: "url(#paint6_linear_214_1952)",
    fillOpacity: 0.47
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 331.677,
    cy: 176.471,
    r: 4.31353,
    fill: "#3700D3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M148.809 201.305C150.086 198.902 153.1 198.037 155.457 199.397C157.812 200.757 158.571 203.798 157.131 206.104L151.849 214.565C150.577 216.603 147.919 217.266 145.839 216.065C143.759 214.864 143.004 212.233 144.131 210.113L148.809 201.305Z",
    fill: "url(#paint7_linear_214_1952)",
    fillOpacity: 0.47
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 153.089,
    cy: 203.516,
    r: 4.31353,
    fill: "#3700D3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M178.574 201.305C179.85 198.902 182.865 198.037 185.221 199.397C187.576 200.757 188.335 203.798 186.895 206.104L181.614 214.565C180.342 216.603 177.684 217.266 175.603 216.065C173.524 214.864 172.769 212.233 173.895 210.113L178.574 201.305Z",
    fill: "url(#paint8_linear_214_1952)",
    fillOpacity: 0.47
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.855,
    cy: 203.516,
    r: 4.31353,
    fill: "#3700D3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M208.338 201.305C209.615 198.902 212.629 198.037 214.986 199.397C217.341 200.757 218.1 203.798 216.66 206.104L211.378 214.565C210.106 216.603 207.448 217.266 205.368 216.065C203.289 214.864 202.533 212.233 203.66 210.113L208.338 201.305Z",
    fill: "url(#paint9_linear_214_1952)",
    fillOpacity: 0.47
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.617,
    cy: 203.516,
    r: 4.31353,
    fill: "#3700D3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M238.103 201.305C239.379 198.902 242.394 198.037 244.75 199.397C247.105 200.757 247.864 203.798 246.424 206.104L241.143 214.565C239.871 216.603 237.213 217.266 235.132 216.065C233.053 214.864 232.298 212.233 233.424 210.113L238.103 201.305Z",
    fill: "url(#paint10_linear_214_1952)",
    fillOpacity: 0.47
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.384,
    cy: 203.516,
    r: 4.31353,
    fill: "#3700D3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M267.868 201.305C269.144 198.902 272.159 198.037 274.515 199.397C276.87 200.757 277.629 203.798 276.189 206.104L270.907 214.565C269.635 216.603 266.977 217.266 264.897 216.065C262.818 214.864 262.063 212.233 263.189 210.113L267.868 201.305Z",
    fill: "url(#paint11_linear_214_1952)",
    fillOpacity: 0.47
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 272.148,
    cy: 203.516,
    r: 4.31353,
    fill: "#3700D3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M297.632 201.305C298.908 198.902 301.923 198.037 304.279 199.397C306.634 200.757 307.393 203.798 305.953 206.104L300.672 214.565C299.4 216.603 296.742 217.266 294.661 216.065C292.582 214.864 291.827 212.233 292.953 210.113L297.632 201.305Z",
    fill: "url(#paint12_linear_214_1952)",
    fillOpacity: 0.47
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 301.913,
    cy: 203.516,
    r: 4.31353,
    fill: "#3700D3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M327.397 201.305C328.673 198.902 331.688 198.037 334.044 199.397C336.399 200.757 337.158 203.798 335.718 206.104L330.436 214.565C329.164 216.603 326.506 217.266 324.426 216.065C322.347 214.864 321.592 212.233 322.718 210.113L327.397 201.305Z",
    fill: "url(#paint13_linear_214_1952)",
    fillOpacity: 0.47
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 331.677,
    cy: 203.516,
    r: 4.31353,
    fill: "#3700D3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M148.809 228.35C150.086 225.947 153.1 225.082 155.457 226.443C157.812 227.802 158.571 230.843 157.131 233.15L151.849 241.61C150.577 243.648 147.919 244.311 145.839 243.11C143.759 241.91 143.004 239.279 144.131 237.158L148.809 228.35Z",
    fill: "url(#paint14_linear_214_1952)",
    fillOpacity: 0.47
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 153.089,
    cy: 230.562,
    r: 4.31353,
    fill: "#3700D3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M178.574 228.35C179.85 225.947 182.865 225.082 185.221 226.443C187.576 227.802 188.335 230.843 186.895 233.15L181.614 241.61C180.342 243.648 177.684 244.311 175.603 243.11C173.524 241.91 172.769 239.279 173.895 237.158L178.574 228.35Z",
    fill: "url(#paint15_linear_214_1952)",
    fillOpacity: 0.47
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.855,
    cy: 230.562,
    r: 4.31353,
    fill: "#3700D3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M208.338 228.35C209.615 225.947 212.629 225.082 214.986 226.443C217.341 227.802 218.1 230.843 216.66 233.15L211.378 241.61C210.106 243.648 207.448 244.311 205.368 243.11C203.289 241.91 202.533 239.279 203.66 237.158L208.338 228.35Z",
    fill: "url(#paint16_linear_214_1952)",
    fillOpacity: 0.47
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.618,
    cy: 230.562,
    r: 4.31353,
    fill: "#3700D3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M238.103 228.35C239.379 225.947 242.394 225.082 244.75 226.443C247.105 227.802 247.864 230.843 246.424 233.15L241.143 241.61C239.871 243.648 237.213 244.311 235.132 243.11C233.053 241.91 232.298 239.279 233.424 237.158L238.103 228.35Z",
    fill: "url(#paint17_linear_214_1952)",
    fillOpacity: 0.47
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.384,
    cy: 230.562,
    r: 4.31353,
    fill: "#3700D3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M267.868 228.35C269.144 225.947 272.159 225.082 274.515 226.443C276.87 227.802 277.629 230.843 276.189 233.15L270.907 241.61C269.635 243.648 266.977 244.311 264.897 243.11C262.818 241.91 262.063 239.279 263.189 237.158L267.868 228.35Z",
    fill: "url(#paint18_linear_214_1952)",
    fillOpacity: 0.47
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 272.148,
    cy: 230.562,
    r: 4.31353,
    fill: "#3700D3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M297.632 228.35C298.908 225.947 301.923 225.082 304.279 226.443C306.634 227.802 307.393 230.843 305.953 233.15L300.672 241.61C299.4 243.648 296.742 244.311 294.661 243.11C292.582 241.91 291.827 239.279 292.953 237.158L297.632 228.35Z",
    fill: "url(#paint19_linear_214_1952)",
    fillOpacity: 0.47
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 301.913,
    cy: 230.562,
    r: 4.31353,
    fill: "#3700D3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M327.397 228.35C328.673 225.947 331.688 225.082 334.044 226.443C336.399 227.802 337.158 230.843 335.718 233.15L330.436 241.61C329.164 243.648 326.506 244.311 324.426 243.11C322.347 241.91 321.592 239.279 322.718 237.158L327.397 228.35Z",
    fill: "url(#paint20_linear_214_1952)",
    fillOpacity: 0.47
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 331.677,
    cy: 230.562,
    r: 4.31353,
    fill: "#3700D3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M148.809 255.396C150.086 252.993 153.1 252.128 155.457 253.488C157.812 254.848 158.571 257.889 157.131 260.195L151.849 268.656C150.577 270.693 147.919 271.357 145.839 270.156C143.759 268.955 143.004 266.324 144.131 264.204L148.809 255.396Z",
    fill: "url(#paint21_linear_214_1952)",
    fillOpacity: 0.47
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 153.087,
    cy: 257.607,
    r: 4.31353,
    fill: "#3700D3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M178.574 255.396C179.85 252.993 182.865 252.128 185.221 253.488C187.576 254.848 188.335 257.889 186.895 260.195L181.614 268.656C180.342 270.693 177.684 271.357 175.603 270.156C173.524 268.955 172.769 266.324 173.895 264.204L178.574 255.396Z",
    fill: "url(#paint22_linear_214_1952)",
    fillOpacity: 0.47
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.855,
    cy: 257.607,
    r: 4.31353,
    fill: "#3700D3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M208.338 255.396C209.615 252.993 212.629 252.128 214.986 253.488C217.341 254.848 218.1 257.889 216.66 260.195L211.378 268.656C210.106 270.693 207.448 271.357 205.368 270.156C203.289 268.955 202.533 266.324 203.66 264.204L208.338 255.396Z",
    fill: "url(#paint23_linear_214_1952)",
    fillOpacity: 0.47
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.618,
    cy: 257.607,
    r: 4.31353,
    fill: "#3700D3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M238.103 255.396C239.379 252.993 242.394 252.128 244.75 253.488C247.105 254.848 247.864 257.889 246.424 260.195L241.143 268.656C239.871 270.693 237.213 271.357 235.132 270.156C233.053 268.955 232.298 266.324 233.424 264.204L238.103 255.396Z",
    fill: "url(#paint24_linear_214_1952)",
    fillOpacity: 0.47
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.384,
    cy: 257.607,
    r: 4.31353,
    fill: "#3700D3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M267.868 255.396C269.144 252.993 272.159 252.128 274.515 253.488C276.87 254.848 277.629 257.889 276.189 260.195L270.907 268.656C269.635 270.693 266.977 271.357 264.897 270.156C262.818 268.955 262.063 266.324 263.189 264.204L267.868 255.396Z",
    fill: "url(#paint25_linear_214_1952)",
    fillOpacity: 0.47
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 272.148,
    cy: 257.607,
    r: 4.31353,
    fill: "#3700D3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M297.632 255.396C298.908 252.993 301.923 252.128 304.279 253.488C306.634 254.848 307.393 257.889 305.953 260.195L300.672 268.656C299.4 270.693 296.742 271.357 294.661 270.156C292.582 268.955 291.827 266.324 292.953 264.204L297.632 255.396Z",
    fill: "url(#paint26_linear_214_1952)",
    fillOpacity: 0.47
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 301.913,
    cy: 257.607,
    r: 4.31353,
    fill: "#3700D3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M327.397 255.396C328.673 252.993 331.688 252.128 334.044 253.488C336.399 254.848 337.158 257.889 335.718 260.195L330.436 268.656C329.164 270.693 326.506 271.357 324.426 270.156C322.347 268.955 321.592 266.324 322.718 264.204L327.397 255.396Z",
    fill: "url(#paint27_linear_214_1952)",
    fillOpacity: 0.47
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 331.677,
    cy: 257.607,
    r: 4.31353,
    fill: "#3700D3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M409.366 331.44L400.573 275.705L453.237 295.957L438.575 307.815L454.935 327.982L441.817 338.624L425.441 318.438L409.366 331.44Z",
    fill: "#14D3A6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M330.593 79.1608C386.899 35.9263 570.844 5.17626 498.303 85.7771C346.278 254.692 333.006 364.488 428.323 337.34",
    stroke: "black",
    strokeWidth: 1.20654
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 178.569,
    y: 371.019,
    width: 236.483,
    height: 27.7505,
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_214_1952",
    x: 49.468,
    y: 67.0732,
    width: 503.129,
    height: 336.626,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.8589
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 27.7505
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_214_1952"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_214_1952",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_214_1952",
    x1: 146.917,
    y1: 190.34,
    x2: 154.205,
    y2: 177.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_214_1952",
    x1: 176.681,
    y1: 190.34,
    x2: 183.97,
    y2: 177.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_214_1952",
    x1: 206.446,
    y1: 190.34,
    x2: 213.734,
    y2: 177.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_214_1952",
    x1: 236.21,
    y1: 190.34,
    x2: 243.499,
    y2: 177.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_214_1952",
    x1: 265.975,
    y1: 190.34,
    x2: 273.263,
    y2: 177.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_214_1952",
    x1: 295.74,
    y1: 190.34,
    x2: 303.028,
    y2: 177.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_214_1952",
    x1: 325.504,
    y1: 190.34,
    x2: 332.792,
    y2: 177.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_214_1952",
    x1: 146.917,
    y1: 217.385,
    x2: 154.205,
    y2: 204.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_214_1952",
    x1: 176.681,
    y1: 217.385,
    x2: 183.97,
    y2: 204.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_214_1952",
    x1: 206.446,
    y1: 217.385,
    x2: 213.734,
    y2: 204.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_214_1952",
    x1: 236.21,
    y1: 217.385,
    x2: 243.499,
    y2: 204.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_214_1952",
    x1: 265.975,
    y1: 217.385,
    x2: 273.263,
    y2: 204.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_214_1952",
    x1: 295.74,
    y1: 217.385,
    x2: 303.028,
    y2: 204.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_214_1952",
    x1: 325.504,
    y1: 217.385,
    x2: 332.792,
    y2: 204.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_214_1952",
    x1: 146.917,
    y1: 244.43,
    x2: 154.205,
    y2: 231.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_214_1952",
    x1: 176.681,
    y1: 244.43,
    x2: 183.97,
    y2: 231.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_214_1952",
    x1: 206.446,
    y1: 244.43,
    x2: 213.734,
    y2: 231.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_214_1952",
    x1: 236.21,
    y1: 244.43,
    x2: 243.499,
    y2: 231.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_214_1952",
    x1: 265.975,
    y1: 244.43,
    x2: 273.263,
    y2: 231.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_214_1952",
    x1: 295.74,
    y1: 244.43,
    x2: 303.028,
    y2: 231.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_214_1952",
    x1: 325.504,
    y1: 244.43,
    x2: 332.792,
    y2: 231.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_214_1952",
    x1: 146.917,
    y1: 271.476,
    x2: 154.205,
    y2: 258.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_214_1952",
    x1: 176.681,
    y1: 271.476,
    x2: 183.97,
    y2: 258.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_214_1952",
    x1: 206.446,
    y1: 271.476,
    x2: 213.734,
    y2: 258.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_214_1952",
    x1: 236.21,
    y1: 271.476,
    x2: 243.499,
    y2: 258.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_214_1952",
    x1: 265.975,
    y1: 271.476,
    x2: 273.263,
    y2: 258.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_214_1952",
    x1: 295.74,
    y1: 271.476,
    x2: 303.028,
    y2: 258.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_214_1952",
    x1: 325.504,
    y1: 271.476,
    x2: 332.792,
    y2: 258.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.71
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserExp);
export default __webpack_public_path__ + "static/media/UserExp.1a6e258331576d2d2b83ea0380978290.svg";
export { ForwardRef as ReactComponent };